import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n'
import './index.css'

// Safety: prevent leaking debug logs (and potential PII) in production.
// Keep warn/error for real issues.
if (import.meta.env.PROD) {
  const noop = () => {};
  (console as any).log = noop;
  (console as any).info = noop;
  (console as any).debug = noop;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)